import { render, staticRenderFns } from "./selectAddress.vue?vue&type=template&id=6c5889f7"
import script from "./selectAddress.vue?vue&type=script&lang=js"
export * from "./selectAddress.vue?vue&type=script&lang=js"
import style0 from "./selectAddress.vue?vue&type=style&index=0&id=6c5889f7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports